import { Component, OnInit } from '@angular/core';
import * as globals from '../../settings';

@Component({
  selector: 'app-server-message',
  templateUrl: './server-message.component.html',
  styleUrls: ['./server-message.component.scss']
})
export class ServerMessageComponent implements OnInit {
  showAlert: boolean;
  serverBannerMessage = globals.serverBannerMessage;
  constructor() {
    this.showAlert = true;
  }

  ngOnInit() {
  }

  closeAlert() {
    this.showAlert = false;
  }
}
